/**
 * Tiny analytics tracker — fire-and-forget POST to /api/events.
 * Errors swallowed so they never affect UX.
 *
 * Usage:
 *   import { trackEvent } from "../lib/analytics";
 *   trackEvent("product_view", { target_id: id, target_name: name });
 *
 * Page views are auto-fired by usePageView() hook below — drop it once in App.jsx.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export async function trackEvent(eventType, payload = {}) {
  try {
    await axios.post(
      `${API}/events`,
      {
        event_type: eventType,
        page: payload.page,
        target_id: payload.target_id ? String(payload.target_id) : undefined,
        target_name: payload.target_name,
        meta: payload.meta,
      },
      { withCredentials: true, timeout: 4000 },
    );
  } catch { /* silent */ }
}

/** SPA page-view tracker. Place once near top of <App /> tree. */
export function usePageView() {
  const location = useLocation();
  useEffect(() => {
    trackEvent("page_view", { page: location.pathname });
  }, [location.pathname]);
}
